<template>
  <div class="form-wrapper">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform">
      <zj-layout-container class="content video-monitor passflow">
        <div class="leftNav">
          <div class="leftSpot"></div>
          <div class="leftNav_title">
            区域列表
            <div class="title_btmLine"></div>
          </div>
          <el-input
            placeholder="搜索区域"
            class="nav-tree-filter"
            v-model="filterText"
          ></el-input>
          <div class="nav-tree-content">
            <el-tree
              style="height: 100%"
              v-loading="loading"
              :element-loading-text="loadingText"
              @node-click="nodeClick"
              :default-checked-keys="defaultCheckedKeys"
              :data="nodes"
              node-key="id"
              :props="defaultProps"
              :filter-node-method="filterNode"
              class="zj-demo-player-tree-device-tree"
              ref="tree"
            ></el-tree>
          </div>
        </div>
        <!-- 右侧内容 -->
        <div class="rightContent">
          <div class="topContent">
            <div class="chart_data">
              <div id="chart" class="analysis_chart"></div>
            </div>
            <div class="table_data">
              <div class="zj-table-container">
                <el-table
                  :data="tableData"
                  ref="multipleTable"
                  border
                  style="width: 100%"
                  fixed
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    width="80"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    prop="BeginTime"
                    label="时间"
                  ></el-table-column>
                  <el-table-column
                    prop="LeaveNum"
                    label="出（人数）"
                  ></el-table-column>
                  <el-table-column
                    prop="EnterNum"
                    label="进（人数）"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </zj-layout-container>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import MyApis from "../../../apis";
export default {
  name: "PassengerflowViewDaHua",
  controller: "UI",
  action: "PassengerflowViewDaHua",
  data() {
    return {
      filterText: "",
      loading: false,
      loadingText: "",
      nodes: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      defaultCheckedKeys:[],
      tableData: []
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {},
  mounted() {
    this.submitIsShowbg(false);
    this.search();
    this.drawFlowChart();
  },
  methods: {
    ...mapActions(["submitIsShowbg"]),
    search() {
      let that = this;
      new MyApis.PassengerFlowApi()
        .GetRegionListForDaHua({
          BeginTime: new Date().format("yyyy-MM-dd"),
          EndTime: new Date().format("yyyy-MM-dd hh:mm:ss")
        })
        .then((r) => {
          r = r.data.Data;
          console.log(r);
          that.nodes = that.convertToTreeNodesfunction(r || []);
          if(that.nodes.length > 0){
            that.defaultCheckedKeys.push(that.nodes[0].id);
            that.defaultLoad(that.nodes[0].deviceId);
          }

          console.log("this.nodes");
          console.log(that.nodes);
        })
        .catch((e) => {
          console.error(e);
          that.$message({
            message: e.RspMsg ? e.RspMsg : "搜索区域失败！",
            type: "error",
          });
        });
    },
    getPassengerFlowList: function (deviceId) {
      let that = this;
      new MyApis.PassengerFlowApi()
        .GetPassengerFlowList({
          DeviceID: deviceId,
          BeginTime: new Date().format("yyyy-MM-dd"),
          EndTime: new Date().format("yyyy-MM-dd hh:mm:ss"),
          ExtQueries: null,
        })
        .then((r) => {
          r = r.data.Data;
          this.tableData = r;
        })
        .catch((e) => {
          console.error(e);
          that.$message({
            message: e.RspMsg ? e.RspMsg : "搜索区域失败！",
            type: "error",
          });
        });
    },
    getChartData: function (deviceId) {
      let that = this;
      new MyApis.PassengerFlowApi()
        .GetChartDataEachHour({
          DeviceID: deviceId,
          BeginTime: new Date().format("yyyy-MM-dd"),
          EndTime: new Date().format("yyyy-MM-dd hh:mm:ss"),
          ExtQueries: null,
        })
        .then((r) => {
          r = r.data.Data;
          this.drawFlowChart(r);
        })
        .catch((e) => {
          console.error(e);
          that.$message({
            message: e.RspMsg ? e.RspMsg : "搜索区域失败！",
            type: "error",
          });
        });
    },
    convertToTreeNodesfunction(list) {
      let result = [];
      for (let i = 0; i < list.length; i++) {
        
        var regionData = list[i];
        var region = {
          id: regionData.AreaID,
          label: regionData.AreaName,
          deviceId:regionData.DeviceID,
          deviceName:regionData.DeviceName,
          children: [],
        };
        result.push(region);
      }
      return result;
    },
    defaultLoad: function (deviceId) {
        this.getPassengerFlowList(deviceId);
        this.getChartData(deviceId);
    },
    // eslint-disable-next-line no-unused-vars
    nodeClick: function (data, node, self) {
      if (node.level == 1) {
        this.getPassengerFlowList(data.deviceId);
        this.getChartData(data.deviceId);
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    drawFlowChart: function (r) {
      r = r || {};
      var defaultOption = {
        title: {
          text: "客流量走势图",
          textStyle: {
            color: "#d6f0ff",
          },
          left: "10%",
        },
        grid: {
          left: "5%",
          right: "5%",
          top: "15%",
          bottom: "5%",
          containLabel: true,
        },
        tooltip: [
          {
            trigger: "axis",
            formatter: "{b} 时<br />{a0}: {c0} 人<br />{a1}: {c1} 人",
          },
        ],
        series: [
          {
            name: "入",
            type: "line",
            data: r.yAxisIn || [0],
            color: ['#449d44']
          },
          {
            name: "出",
            type: "line",
            data: r.yAxisOut || [0],
            color: ['#31b0d5']
          },
        ],
        legend: [
          {
            data: ["入", "出"],
            textStyle: {
              color: "#d6f0ff",
            },
          },
        ],
        yAxis: [
          {
            name: "人数",
            type: "value",
            min :10,
            minInterval: 1,
            nameTextStyle: {
              color: "#d6f0ff",
              //fontSize: 12
            },
            axisLine: {
              lineStyle: {
                color: "#00bcfe",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#257dd4",
              },
            },
            axisLabel: {
              textStyle: {
                //fontSize: 12,
                color: "#d6f0ff",
              },
            },
          },
        ],
        xAxis: [
          {
            
            name: "时间",
            type: "category",
            boundaryGap: false,
            nameTextStyle: {
              color: "#d6f0ff",
              //fontSize: 12
            },
            axisLine: {
              lineStyle: {
                color: "#00bcfe",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#257dd4",
              },
            },
            axisLabel: {
              textStyle: {
                //fontSize: 12,
                color: "#d6f0ff",
              },
            },
            data: r.xAxis || [],
          },
        ],
      };

      var chartDom = document.getElementById("chart");
      // eslint-disable-next-line no-undef
      var myChart = echarts.getInstanceByDom(chartDom);
      if (!myChart) {
        // eslint-disable-next-line no-undef
        myChart = echarts.init(chartDom);
        myChart.setOption(defaultOption);
      }
      myChart.clear();
      myChart.setOption(defaultOption);

      window.onresize = function () {
        var chartDom = document.getElementById("chart");
        // eslint-disable-next-line no-undef
        var myChart = echarts.getInstanceByDom(chartDom);
        if (myChart) {
          myChart.resize();
        }
      };
    },
  },
  destoryed() {
    this.submitIsShowbg(true);
  },
};
</script>

<style scoped>

.video-monitor.passflow{
  overflow: hidden !important;;
}
.rightContent {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.topContent {
  flex: 1;
  overflow: hidden;
  width: 100%;
  padding-left:1.5rem;
  box-sizing: border-box;
}


.chart_data {
  width: 100%;
  height: 50%;
  float: left;
  overflow: hidden;
}

.chart_data .chart {
  width: 100%;
  height: 100%;
}

.table_data {
  width: 100%;
  height: 50%;
  padding-top: 1rem;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  float: left;
}

.table_data .zj-table-container {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}

.table_data .zj-table-container .zj-camera-player {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>